/*
  Far & Away "Top 5 Reasons Ethical Tableware" landing page (sections/fa-eth-*.liquid).
  Plain JavaScript, no dependencies. Reproduces the behaviour of the Replo page:
  collapsibles, carousels (arrows, thumbnails/dots, swipe), hover states, the set selector
  (12/16/36 tabs switch the visible product), colour swatches (prices, images, Klarna amount,
  out-of-stock state), add to cart through the theme's own cart drawer, the "Meet the Makers"
  video player, the scroll-to buttons and the currency-aware delivery copy.
  Based on assets/fa-lp.js from the bundles landing page.
*/
(function () {
  'use strict';

  var all = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var classes = function (el, add, remove) {
    (remove || '').split(' ').forEach(function (c) { if (c) el.classList.remove(c); });
    (add || '').split(' ').forEach(function (c) { if (c) el.classList.add(c); });
  };

  /* Money formatting: the bundle section renders 123456 cents through Liquid's money filter
     (data-fe-money-sample, e.g. "€1.234,56", "£1,234.56", "$1,234.56") and prefix, separators
     and suffix are read from it, so prices re-rendered here match the server-rendered ones. */
  var money = { prefix: '$', thousands: ',', decimal: '.', decimals: true, suffix: '' };
  function learnMoney(sample) {
    var m = sample && sample.match(/^(\D*)1(\D*)234(?:(\D*)56)?(\D*)$/);
    if (!m) return;
    money = { prefix: m[1], thousands: m[2], decimal: m[3] || '', decimals: !!m[3], suffix: m[4] };
  }
  function formatMoney(cents, fmt) {
    var n = (Number(cents) || 0) / 100;
    if (fmt === 'nz') n = Math.round(n); // the Replo page rounds to whole units before money_without_trailing_zeros
    var parts = (money.decimals ? n.toFixed(2) : String(Math.round(n))).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, money.thousands);
    var dec = parts[1] || '';
    if (fmt === 'nz' && /^0*$/.test(dec)) dec = '';
    return money.prefix + whole + (dec ? money.decimal + dec : '') + money.suffix;
  }

  /* ---------------- Delivery copy in converted currencies ---------------- */
  function initDelivery(scope) {
    all('[data-fe-ship-convert]', scope).forEach(function (section) {
      var cur = window.Shopify && window.Shopify.currency;
      var rate = cur ? parseFloat(cur.rate) : NaN;
      if (!cur || !cur.active || !(rate > 0)) return;
      var symbols = { CHF: 'CHF ', CZK: 'Kč ', DKK: 'kr ', HUF: 'Ft ', PLN: 'zł ', SEK: 'kr ', USD: '$', EUR: '€', GBP: '£' };
      var fmt = function (base) {
        var v = Math.round(base * rate * 100) / 100;
        return (symbols[cur.active] || cur.active + ' ') + (v % 1 === 0 ? String(v) : v.toFixed(2));
      };
      var free = parseFloat(section.getAttribute('data-fe-ship-free-base'));
      var cost = parseFloat(section.getAttribute('data-fe-ship-cost-base'));
      if (free > 0) all('[data-fe-ship="free"]', section).forEach(function (el) { el.textContent = fmt(free); });
      if (cost > 0) all('[data-fe-ship="cost"]', section).forEach(function (el) { el.textContent = fmt(cost); });
    });
  }

  /* ---------------- Collapsibles ---------------- */
  function initCollapsibles(scope) {
    all('[data-fe-coll]', scope).forEach(function (coll) {
      if (coll.__fa) return; coll.__fa = true;
      var trigger = coll.querySelector('[data-fe-coll-trigger]');
      var content = coll.querySelector('[data-fe-coll-content]');
      if (!trigger || !content) return;
      var toggle = function () {
        var open = trigger.getAttribute('aria-expanded') !== 'true';
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        coll.setAttribute('data-fe-open', open ? 'true' : 'false');
        if (open) content.removeAttribute('hidden'); else content.setAttribute('hidden', '');
        var add = trigger.getAttribute('data-fe-open-add') || '';
        if (open) classes(trigger, add, ''); else classes(trigger, '', add);
        all('path[data-fe-d-open]', trigger).forEach(function (p) {
          if (!p.hasAttribute('data-fe-d-closed')) p.setAttribute('data-fe-d-closed', p.getAttribute('d'));
          p.setAttribute('d', open ? p.getAttribute('data-fe-d-open') : p.getAttribute('data-fe-d-closed'));
        });
      };
      trigger.addEventListener('click', toggle);
      trigger.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }

  /* ---------------- Hover states ---------------- */
  function initHover(scope) {
    all('[data-fe-hover-add]', scope).forEach(function (el) {
      if (el.__faHover) return; el.__faHover = true;
      var add = el.getAttribute('data-fe-hover-add') || '';
      el.addEventListener('mouseenter', function () { classes(el, add, ''); });
      el.addEventListener('mouseleave', function () { classes(el, '', add); });
    });
  }

  /* ---------------- Carousels ---------------- */
  function Carousel(root) {
    this.root = root;
    this.index = 0;
    this.viewports = all('[data-fe-part="slides"]', root);
    this.prev = all('[data-fe-part="nav-button"][data-fe-dir="previous"]', root);
    this.next = all('[data-fe-part="nav-button"][data-fe-dir="next"]', root);
    this.live = root.querySelector('.fa-eth-sr-only');
    var self = this;
    this.prev.forEach(function (b) { b.addEventListener('click', function () { self.go(self.index - 1); }); });
    this.next.forEach(function (b) { b.addEventListener('click', function () { self.go(self.index + 1); }); });
    this.bindDots();
    this.viewports.forEach(function (vp) { self.swipe(vp); });
    window.addEventListener('resize', function () { self.go(self.index, true); });
  }
  Carousel.prototype.bindDots = function () {
    var self = this;
    this.dots = all('[data-fe-dot]', this.root);
    // active classes of dots = classes on the first (active) dot that the second one lacks
    this.dotActive = [];
    if (this.dots.length > 1) {
      var a = this.dots[0].classList, b = this.dots[1].classList;
      for (var i = 0; i < a.length; i++) if (!b.contains(a[i])) this.dotActive.push(a[i]);
    }
    this.dots.forEach(function (d, i) {
      if (d.__faDot) return; d.__faDot = true;
      d.addEventListener('click', function () { self.go(i); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.go(i); } });
    });
  };
  Carousel.prototype.metrics = function (vp) {
    var track = vp.querySelector('[data-fe-part="slide-track"]');
    if (!track || !vp.offsetWidth) return null;
    var slides = all(':scope > [data-fe-part="slide"]', track);
    if (!slides.length) return null;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    var w = slides[0].getBoundingClientRect().width;
    var vw = vp.getBoundingClientRect().width;
    var perPage = Math.max(1, Math.round((vw + gap) / (w + gap)));
    var center = vp.getAttribute('data-fe-align') === 'center';
    return { track: track, slides: slides, step: w + gap, max: Math.max(0, slides.length - perPage), offset: center ? (vw - w) / 2 : 0, count: slides.length };
  };
  Carousel.prototype.count = function () {
    var n = 0; this.viewports.forEach(function (vp) { var m = this.metrics(vp); if (m) n = Math.max(n, m.max); }, this); return n;
  };
  Carousel.prototype.go = function (i, instant) {
    var max = this.count();
    i = Math.max(0, Math.min(i, max));
    this.index = i;
    this.viewports.forEach(function (vp) {
      var m = this.metrics(vp); if (!m) return;
      var idx = Math.min(i, m.max);
      m.track.style.transitionProperty = instant ? 'none' : 'transform';
      m.track.style.transitionDuration = instant ? '0ms' : '250ms';
      m.track.style.transitionTimingFunction = 'ease';
      var x = m.slides[idx] ? m.slides[idx].offsetLeft - m.slides[0].offsetLeft : idx * m.step;
      m.track.style.transform = 'translate3d(' + (-x + Math.round(m.offset)) + 'px, 0px, 0px)';
      m.slides.forEach(function (s, k) { if (k === idx) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
    }, this);
    var self = this;
    this.prev.forEach(function (b) { self.disable(b, i <= 0); });
    this.next.forEach(function (b) { self.disable(b, i >= max); });
    this.dots.forEach(function (d, k) {
      self.dotActive.forEach(function (c) { d.classList.toggle(c, k === i); });
      d.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
    if (this.live) this.live.textContent = 'Slide ' + (i + 1) + ' of ' + (this.maxSlides() || 1);
  };
  Carousel.prototype.maxSlides = function () {
    var n = 0; this.viewports.forEach(function (vp) { var t = vp.querySelector('[data-fe-part="slide-track"]'); if (t) n = Math.max(n, t.children.length); }); return n;
  };
  Carousel.prototype.disable = function (btn, off) {
    var cls = btn.getAttribute('data-fe-dis');
    if (cls) cls.split(' ').forEach(function (c) { if (c) btn.classList.toggle(c, off); });
    if (off) btn.setAttribute('disabled', ''); else btn.removeAttribute('disabled');
  };
  Carousel.prototype.swipe = function (vp) {
    var self = this, startX = 0, startY = 0, dx = 0, active = false, horizontal = null, base = 0, m = null;
    var down = function (x, y) { m = self.metrics(vp); if (!m) return; active = true; horizontal = null; startX = x; startY = y; dx = 0;
      var cur = new DOMMatrixReadOnly(getComputedStyle(m.track).transform); base = cur.m41; };
    var move = function (x, y, e) {
      if (!active) return;
      dx = x - startX; var dy = y - startY;
      if (horizontal === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) horizontal = Math.abs(dx) > Math.abs(dy);
      if (!horizontal) return;
      if (e && e.cancelable) e.preventDefault();
      m.track.style.transitionProperty = 'none'; m.track.style.transitionDuration = '0ms';
      m.track.style.transform = 'translate3d(' + (base + dx) + 'px, 0px, 0px)';
    };
    var up = function () {
      if (!active) return; active = false;
      if (!horizontal) return;
      var threshold = Math.min(60, (m ? m.step : 300) * 0.2);
      if (dx < -threshold) self.go(self.index + 1); else if (dx > threshold) self.go(self.index - 1); else self.go(self.index);
      vp.__faDragged = Math.abs(dx) > 6;
    };
    vp.addEventListener('touchstart', function (e) { var t = e.touches[0]; down(t.clientX, t.clientY); }, { passive: true });
    vp.addEventListener('touchmove', function (e) { var t = e.touches[0]; move(t.clientX, t.clientY, e); }, { passive: false });
    vp.addEventListener('touchend', up);
    vp.addEventListener('touchcancel', up);
    vp.addEventListener('mousedown', function (e) { if (e.button !== 0) return; down(e.clientX, e.clientY); e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { move(e.clientX, e.clientY); });
    window.addEventListener('mouseup', up);
    vp.addEventListener('click', function (e) { if (vp.__faDragged) { e.preventDefault(); e.stopPropagation(); vp.__faDragged = false; } }, true);
  };

  /* ---------------- Set selector + product boxes ---------------- */
  function setImages(box, list) {
    if (!list || !list.length) return;
    // slides: every track in the box (desktop + mobile) is rebuilt from its first slide
    all('[data-fe-part="slide-track"]', box).forEach(function (track) {
      var slides = all(':scope > [data-fe-part="slide"]', track);
      if (!slides.length) return;
      var tpl = track.__faSlideTpl || (track.__faSlideTpl = slides[0].cloneNode(true));
      while (slides.length > list.length) { track.removeChild(slides.pop()); }
      while (slides.length < list.length) { var c = tpl.cloneNode(true); track.appendChild(c); slides.push(c); }
      slides.forEach(function (slide, k) {
        var src = list[k];
        slide.setAttribute('data-fe-index', String(k));
        slide.setAttribute('aria-label', 'Slide ' + (k + 1));
        var pic = slide.querySelector('picture');
        if (pic) pic.style.setProperty('--fa-eth-attributes-currentitem', 'url("' + src + '")');
        all('source', slide).forEach(function (s) {
          var w = (s.getAttribute('srcset') || '').match(/[?&]width=\d+/);
          s.setAttribute('srcset', src + (w ? (src.indexOf('?') > -1 ? '&' : '?') + w[0].slice(1) : ''));
        });
        var img = slide.querySelector('img'); if (img) img.setAttribute('src', src);
      });
    });
    // thumbnails/dots
    var dots = all('[data-fe-dot]', box);
    if (dots.length) {
      var parent = dots[0].parentNode;
      var dtpl = parent.__faDotTpl || (parent.__faDotTpl = dots[0].cloneNode(true));
      while (dots.length > list.length) { parent.removeChild(dots.pop()); }
      while (dots.length < list.length) { var d = dtpl.cloneNode(true); d.__faDot = false; parent.appendChild(d); dots.push(d); }
      dots.forEach(function (d, k) {
        d.style.setProperty('--fa-eth-attributes-currentitem', 'url("' + list[k] + '")');
        d.setAttribute('aria-label', 'Go to slide ' + (k + 1));
      });
    }
  }

  function initBundle(section) {
    var parent = section.querySelector('[data-fe-bundle]');
    if (!parent) return;
    var states = JSON.parse(parent.getAttribute('data-fe-states') || '{}');
    var stateClasses = Object.keys(states).map(function (k) { return states[k]; }).filter(Boolean);
    learnMoney(parent.getAttribute('data-fe-money-sample'));

    all('[data-fe-product]', parent).forEach(function (box) {
      var data;
      try { data = JSON.parse(box.querySelector('[data-fe-data]').textContent); } catch (e) { return; }
      var form = box.querySelector('[data-fe-form]');
      var carouselRoot = box.querySelector('[data-fe-carousel]');
      var carousel = carouselRoot && carouselRoot.__faCarousel;
      var list = box.querySelector('[data-fe-swatches]');
      var selectedCls = (list && list.getAttribute('data-fe-selected-class') || '').split(' ').filter(Boolean);
      var options = list ? all('[role="option"]', list) : [];
      var current = data.variants.filter(function (v) { return v.id === data.variant; })[0] || data.variants[0];
      var klarna = box.querySelector('klarna-placement');
      var terms = box.querySelector('shopify-payment-terms');

      function render(variant) {
        current = variant;
        if (form) form.querySelector('[name="id"]').value = variant.id;
        all('[data-fe-compare]', box).forEach(function (el) { (el.querySelector('span') || el).innerHTML = '<span class="money">' + formatMoney(variant.compare, el.getAttribute('data-fe-fmt')) + '</span>'; });
        all('[data-fe-price]', box).forEach(function (el) { (el.querySelector('span') || el).innerHTML = '<span class="money">' + formatMoney(variant.price, el.getAttribute('data-fe-fmt')) + '</span>'; });
        all('[data-fe-diff]', box).forEach(function (el) { (el.querySelector('span') || el).innerHTML = '<span class="money">' + formatMoney(Math.max(0, variant.compare - variant.price), el.getAttribute('data-fe-fmt')) + '</span>'; });
        all('[data-fe-color-label]', box).forEach(function (el) { (el.querySelector('span') || el).textContent = variant.color; });
        if (klarna) {
          klarna.setAttribute('data-purchase-amount', String(variant.price));
          window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
          window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        }
        if (terms) terms.setAttribute('data-amount', String(variant.price));
        // Only the 12-piece block has an out-of-stock button on the Replo page; the other blocks keep their ATC whatever the availability
        if (box.querySelector('[data-fe-oos]')) {
          all('[data-fe-atc-wrap]', box).forEach(function (el) { el.style.display = variant.available ? '' : 'none'; });
          all('[data-fe-oos]', box).forEach(function (el) { el.style.display = variant.available ? '' : (window.innerWidth > 1024 ? 'flex' : 'inline'); });
        }
        options.forEach(function (o) {
          var on = o.getAttribute('data-fe-value') === variant.color;
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          selectedCls.forEach(function (c) { o.classList.toggle(c, on); });
        });
      }

      options.forEach(function (o) {
        var pick = function () {
          var v = data.variants.filter(function (x) { return x.color === o.getAttribute('data-fe-value'); })[0];
          if (!v || v === current) return;
          render(v); setImages(box, data.images[v.color]);
          if (carousel) { carousel.bindDots(); carousel.go(0, true); }
        };
        o.addEventListener('click', pick);
        o.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      });

      all('[data-fe-tab]', box).forEach(function (tab) {
        var inner = tab.querySelector('[role="button"]') || tab;
        var go = function () {
          var key = tab.getAttribute('data-fe-tab');
          stateClasses.forEach(function (c) { parent.classList.remove(c); });
          if (states[key]) parent.classList.add(states[key]);
          window.requestAnimationFrame(function () { all('[data-fe-carousel]', parent).forEach(function (c) { if (c.__faCarousel) c.__faCarousel.go(c.__faCarousel.index, true); }); });
        };
        inner.addEventListener('click', go);
        inner.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
      });

      all('[data-fe-atc]', box).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          addToCart(current.id, 1, form);
        });
      });
      box.__faRender = render;
    });
  }

  function addToCart(id, qty, form) {
    var loader = document.querySelector('.loader');
    if (loader) loader.classList.remove('hide_loader');
    var done = function () { if (loader) loader.classList.add('hide_loader'); };
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed ' + r.status);
      return r.json();
    }).then(function () {
      // Same path as the theme's own product page and the Replo page's executeJavascript action: refresh the cart drawer and open it.
      if (typeof window.updatecartnew === 'function') window.updatecartnew('/cart/update');
      else { done(); window.location.href = root + 'cart'; }
    }).catch(function () {
      done();
      if (form) form.submit();
    });
  }

  /* ---------------- Video player (Meet the Makers) ---------------- */
  function initVideo(box) {
    var video = box.querySelector('video');
    if (!video) return;
    var play = box.querySelector('[data-fe-video-play]');
    var mute = box.querySelector('[data-fe-video-mute]');
    var fs = box.querySelector('[data-fe-video-fs]');
    var overlay = box.querySelector('[data-fe-video-overlay]');
    var swap = function (btn, alt, label) {
      var p = btn.querySelector('svg path'); if (!p) return;
      if (!p.hasAttribute('data-fe-d-closed')) p.setAttribute('data-fe-d-closed', p.getAttribute('d'));
      p.setAttribute('d', alt ? p.getAttribute('data-fe-d-open') : p.getAttribute('data-fe-d-closed'));
      var svg = btn.querySelector('svg'); if (svg && label) svg.setAttribute('aria-label', label);
    };
    var start = function () {
      if (!video.getAttribute('src') && video.getAttribute('data-fe-src')) video.setAttribute('src', video.getAttribute('data-fe-src'));
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      video.play();
    };
    var toggle = function () { if (video.paused) start(); else video.pause(); };
    video.addEventListener('play', function () { if (play) swap(play, true, 'Pause'); });
    video.addEventListener('pause', function () { if (play) swap(play, false, 'Play'); });
    if (play) play.addEventListener('click', toggle);
    if (overlay) overlay.addEventListener('click', start);
    video.addEventListener('click', toggle);
    if (mute) mute.addEventListener('click', function () {
      video.muted = !video.muted;
      swap(mute, video.muted, video.muted ? 'Unmute' : 'Mute');
    });
    if (fs) fs.addEventListener('click', function () {
      var el = video;
      if (document.fullscreenElement) document.exitFullscreen();
      else if (el.requestFullscreen) el.requestFullscreen();
      else if (el.webkitEnterFullscreen) el.webkitEnterFullscreen();
    });
    [play, mute, fs].forEach(function (b) {
      if (b) b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); b.click(); } });
    });
  }

  /* ---------------- Scroll buttons ---------------- */
  function initScroll(scope) {
    all('[data-fe-scroll]', scope).forEach(function (el) {
      if (el.__faScroll) return; el.__faScroll = true;
      el.addEventListener('click', function (e) {
        var sel = el.getAttribute('data-fe-scroll') || '';
        var target = sel.charAt(0) === '#' ? document.getElementById(sel.slice(1)) : document.querySelector(sel);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    var scope = document;
    initCollapsibles(scope);
    initHover(scope);
    all('[data-fe-carousel]', scope).forEach(function (c) {
      if (c.__faCarousel) return;
      c.__faCarousel = new Carousel(c);
      var box = c.closest('[data-fe-product]'); if (box) box.__faCarousel = c.__faCarousel;
    });
    all('[data-fe-section="product"]', scope).forEach(initBundle);
    all('[data-fe-video]', scope).forEach(initVideo);
    initScroll(scope);
    initDelivery(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
